<template>
  <div :id="'cont_' + formProperty.nativename" :class="getCompCSS()">
    <div v-if="subtypeArray.length < formProperty.cardinality" class="subItemRow" :class="{subFormHead: (!inGroupCard || (inGroupCard && inGroupWithMargin)), subFormGroupHead: (inGroupCard && !inGroupWithMargin)}">
      <div class="subForm"></div>
      <div v-if="!(readOnly || formProperty.readonly) && subtypeArray && subtypeArray.length < 1">
        <q-btn size="md" unelevated color="primary" @click="btnAdd()" class="btnAdd q-mt-sm">
          <span>+</span>
        </q-btn>
      </div>
    </div>
    <div v-else class="subItemRow subFormHead">
    </div>
    <div v-for="(subtypeItem, index) in subtypeArray" :key="subtypeItem.count">
      <q-separator v-if="index > 0" inset/>
      <div class="subItemRow">
        <!-- ref function adds element reference to local array for later validateOnly function calls of Formular.vue component during field validation -->
        <formular :ref="(el) => {if(el) subformRefs[index] = el}" :isSubtype="true" :subtypeCount="subtypeItem.count" :propObjClassID="formProperty.subClassID" :subItem="subtypeItem" @onChange="onChange"
                  :subObjInstanceID="formProperty.existingSubObjectIDs[index]"
                  :focusInSubtype="formProperty.initialBehavior === StaticData.SUBFORM_INITIAL_BEHAVIOR.BUTTON_AND_FORM ? subtypeItem.count > 0 : true"
                  class="subForm" :class="{fullsizeSubForm: !(formProperty.initialBehavior === StaticData.SUBFORM_INITIAL_BEHAVIOR.BUTTON_ONLY && subtypeArray.length > 0 ||
                  formProperty.initialBehavior === StaticData.SUBFORM_INITIAL_BEHAVIOR.BUTTON_AND_FORM && subtypeArray.length > 1)}"
                  :parentFormPointer="formProperty" :propReadonly="readOnly || formProperty.readonly"/>

        <div v-if="(formProperty.initialBehavior === StaticData.SUBFORM_INITIAL_BEHAVIOR.BUTTON_ONLY && subtypeArray.length > 0 ||
                    formProperty.initialBehavior === StaticData.SUBFORM_INITIAL_BEHAVIOR.BUTTON_AND_FORM && subtypeArray.length > 1) && !(readOnly || formProperty.readonly)"
             class="buttonWrapperMinus q-pt-md">
          <q-btn size="md" unelevated color="primary" @click="btnAdd()" class="btnAdd q-mb-md" v-if="!(readOnly || formProperty.readonly) && index === subtypeArray.length - 1">
            <span>+</span>
          </q-btn>
          <q-btn size="md" unelevated color="red" @click="btnRemove(index)" class="btnRemove">
            <span>-</span>
          </q-btn>
        </div>
      </div>
    </div>
    <span class="r_error">{{ formProperty.errorMsg }}</span>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {requiredIf} from '@vuelidate/validators'
import {fldComponentsMixin} from './mixins/fldComponent'
import {StaticData} from '../../classes/StaticData'
import {setCssVar} from 'quasar'
import {defineAsyncComponent} from "vue"

export default {
  mixins: [fldComponentsMixin],
  components: {
    formular: defineAsyncComponent(() => import('../Formular.vue'))
  },
  props: [
    'formProperty',
    'readOnly',
    'inGroupCard'
  ],
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      StaticData,
      subtypeArray: [],
      subformRefs: [],
      value: this.getValue(),
      subtypeItemCounter: 0, //used to create new unique formular components and to identify the correct ones to remove
      inGroupWithMargin: false
    }
  },
  validations() {
    return this.getValidations()
  },
  watch: {
    subtypeCount: function () {
      this.getValue()
    }
  },
  methods: {
    getValue() {
      if (this.subtypeArray && this.subtypeArray.length !== 0) {
        this.formProperty.value = this.formProperty.subClassID
        return this.formProperty.subClassID
      } else {
        this.formProperty.value = ""
        return ""
      }
    },
    addSubform(subForm) {
      if (subForm[0]) {
        this.formProperty.subForms.push(subForm[0])
      }
    },
    btnAdd() {
      if (this.subtypeArray.length == 0) {
        this.eventBus.incrementSubtypeCount()
      }
      this.eventBus.refreshParentForm(this.formProperty)
    },
    onContinueButtonAdd(data) {
      if (this.formProperty.nativename == data.nativename) {
        this.subtypeArray.push({count: this.subtypeItemCounter})
        this.subtypeItemCounter++
      }
    },
    btnRemove(index) {
      this.subtypeArray.splice(index, 1);
      if (this.subtypeArray.length == 0) {
        this.eventBus.decrementSubtypeCount()
      }
    },
    getValidations() {
      let result = {value: {}}
      result.value['requiredIf'] = requiredIf(() => {
        if (this.formProperty.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
          return (this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) &&
            this.formProperty.showThroughDependency === true
        } else {
          return this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY
        }
      })
      return result
    },
    getErrorLabel() {
      let result = ""
      const errors = this.v$.$errors.map(err => err.$validator)
      if (errors.includes("requiredIf")) {
        result = this.formProperty.infoRequired && this.formProperty.infoRequired !== "" ? this.formProperty.infoRequired : this.formProperty.title + " muss befüllt werden."
      } else {
        result = this.formProperty.errorMsg
      }
      return result
    },
    onChange() {
      this.formProperty.invalid = false
      this.formProperty.errorMsg = ""
      this.v$.$touch()
      this.value = this.getValue()
      this.formProperty.value = this.value
      this.setErrorBrandColor()
      this.$emit('onChange', {classID: this.formProperty.classID, nativename: this.formProperty.nativename, deleteDependentFields: false, value: this.value})
    },
    setErrorBrandColor() {
      try {
        if (this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) {
          setCssVar('negative', '#f57c00', document.getElementById('cont_' + this.formProperty.nativename))
        } else {
          setCssVar('negative', '#c10015', document.getElementById('cont_' + this.formProperty.nativename))
        }
      } catch (e) {
      }
    }
  },

  beforeUnmount() {
    this.eventBus.off('onContinueButtonAdd', this.onContinueButtonAdd)
  },

  mounted: function () {
    this.eventBus.on('onContinueButtonAdd', this.onContinueButtonAdd)

    if (this.formProperty.existingSubObjectIDs && this.formProperty.existingSubObjectIDs.length > 0) {
      this.formProperty.existingSubObjectIDs.forEach((x) => {
        this.subtypeArray.push({count: this.subtypeItemCounter})
        this.subtypeItemCounter++
      })
    } else if (this.formProperty.initialBehavior === StaticData.SUBFORM_INITIAL_BEHAVIOR.BUTTON_AND_FORM) {
      this.subtypeArray.push({count: this.subtypeItemCounter})
      this.subtypeItemCounter++
    }


    if (this.inGroupCard && this.formProperty.parentForm) {
      let firstOtherVisibleFieldIndex = -1
      let thisIndex = -1
      for (let x = 0; x < this.formProperty.parentForm.length; x++) {
        let tempField = this.formProperty.parentForm[x]
        if (tempField.nativename != this.formProperty.nativename && firstOtherVisibleFieldIndex == -1) {
          if (tempField.fieldgroupTitle == this.formProperty.fieldgroupTitle && !tempField.systemParameter &&
            tempField.renderOnFrontend && (tempField.showThroughDependency == true || tempField.masterPropertyMode != StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
            firstOtherVisibleFieldIndex = x
          }
        }
        if (tempField.nativename == this.formProperty.nativename) {
          thisIndex = x
        }
      }
      if (thisIndex > firstOtherVisibleFieldIndex && firstOtherVisibleFieldIndex != -1) {
        this.inGroupWithMargin = true
      }
    }


    this.formProperty.validate = () => {
      this.value = this.getValue()
      this.v$.$reset()
      this.v$.$touch()
      this.formProperty.invalid = this.v$.value.$error
      this.formProperty.errorMsg = this.getErrorLabel()
      this.setErrorBrandColor()
      this.formProperty.subForms = []
      if (!this.formProperty.invalid) {
        if (this.formProperty.renderOnFrontend && (this.formProperty.showThroughDependency == true || this.formProperty.masterPropertyMode != StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
          this.subformRefs.forEach((x) => {
            let formular = x.validateOnly()
            if (formular) {
              this.addSubform(formular)
              if (formular.invalidLazyinSub) {
                delete formular.invalidLazyinSub
                this.formProperty.invalid = true
              }
            } else {
              this.formProperty.invalid = true
            }
          })
        }
      }
    }

    this.formProperty.setValid = () => {
      let tmp = this.value;
      this.value = "";
      this.value = tmp // bug? - rerender field & errorstats
      this.formProperty.errorMsg = ""
      this.formProperty.invalid = false
      this.v$.$reset()
    }

    this.formProperty.setError = (errMsg) => {
      let tmp = this.value;
      this.value = "";
      this.value = tmp
      this.formProperty.errorMsg = errMsg
      this.formProperty.invalid = true
      this.v$.$touch()
    }
  },

  beforeUpdate() {
    this.subformRefs = []
  }
}
</script>

<style lang="sass">
.r_error
  color: var(--q-color-negative)
  font-size: 12px
  line-height: 1

.q-field-label
  font-weight: bold

.subItemRow
  width: 100%
  display: table
  margin-bottom: 10px

.subForm
  width: 95%
  display: table-cell

.fullsizeSubForm
  width: 100%
  display: table-cell

.buttonWrapper
  width: 5%
  display: table-cell
  vertical-align: middle

.buttonWrapperMinus
  width: 5%
  display: table-cell
  vertical-align: top

.subFormHead
  margin-top: 20px

.subFormGroupHead
  margin-top: -45px

.btnRemove
  text-align: center
  width: 100%

.btnAdd
  width: 100%
  text-align: center

.btnAdd .q-btn__wrapper
  padding: 0 !important

.btnRemove .q-btn__wrapper
  padding: 0 !important
</style>
